import { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import { FiltersDialog } from "./FiltersDialog/FiltersDialog";
import { FiltersChips } from "./FiltersChips/FiltersChips";
import IconButton from "@mui/material/IconButton";
import { Replay } from "@mui/icons-material";
import { useWorkspaceStore } from "../../../store/workspace/WorkspaceStore";
import { Box, Chip, Tooltip } from "@mui/material";
import { useMatchDataProcessingStore } from "../../../store/MatchDataProcessingStore";
import { useFiltersContext } from "./FiltersContext";
import { useOpportunityTypeFilterValidation } from "../../../components/filters/OpportunityType/hooks/useOpportunityTypeFilterValidation";
import { CompanyTypeFilter } from "./CompanyTypeFilter";

export const Filters = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Monitor and auto-clear invalid opportunity type filters
  useOpportunityTypeFilterValidation();

  const setUserFilters = useWorkspaceStore((state) => state.setUserFilters);
  const userFilters = useWorkspaceStore((state) => state.userFilters);
  const workspaceId = useWorkspaceStore((state) => state.draft?.id);
  const stopMatchDataProcessing = useMatchDataProcessingStore(
    (state) => state.stopProcessing
  );
  const { setShownConflictTypes, hasAnyOverrides } = useFiltersContext();
  const hasCompanyMatchBeingProcessed = useMatchDataProcessingStore((state) =>
    workspaceId
      ? state.getProcessingFile(workspaceId, "uploadedAccounts")
      : false
  );

  const onClickReset = () => {
    if (hasCompanyMatchBeingProcessed && workspaceId) {
      stopMatchDataProcessing(workspaceId, "uploadedAccounts");
    }
    setShownConflictTypes(new Set());
    setUserFilters({});
  };

  const handleOpenFiltersDialog = () => {
    setIsOpen(true);
  };

  const hasFiltersApplied = useMemo(
    () =>
      Object.keys(userFilters || {}).length > 0 ||
      hasCompanyMatchBeingProcessed,
    [userFilters, hasCompanyMatchBeingProcessed]
  );

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center" padding={1}>
        <Box width="120px" margin={1}>
          <Button
            data-testid="workspace-filters-add-btn"
            variant="outlined"
            color="secondary"
            onClick={handleOpenFiltersDialog}
            startIcon={<AddIcon />}
            size="small"
            sx={{ height: 30, width: "120px" }}
          >
            Add Filter
          </Button>
        </Box>
        <CompanyTypeFilter />
        {hasAnyOverrides && (
          <Chip
            data-testid="workspace-market-override-chip"
            label="Market Definition Override"
            color="warning"
            size="medium"
          />
        )}
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          flexWrap="wrap"
          margin={1}
          justifyContent={"flex-start"}
          alignContent={"start"}
          alignSelf={"start"}
          padding={2}
          gap={1}
        >
          <FiltersChips />
          {hasFiltersApplied && (
            <Tooltip title="Reset Filters">
              <IconButton
                data-testid="workspace-filters-reset-btn"
                size="small"
                sx={{ height: 24, width: 24 }}
                onClick={onClickReset}
              >
                <Replay sx={{ height: 18 }} />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
      {isOpen && <FiltersDialog isOpen={isOpen} setIsOpen={setIsOpen} />}
    </>
  );
};
